<script setup lang="ts"></script>

<template>
  <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1691_7771)">
      <path
        d="M9.91675 2.24992H12.2501C12.4048 2.24992 12.5532 2.31138 12.6626 2.42077C12.772 2.53017 12.8334 2.67854 12.8334 2.83325V12.1666C12.8334 12.3213 12.772 12.4697 12.6626 12.5791C12.5532 12.6885 12.4048 12.7499 12.2501 12.7499H1.75008C1.59537 12.7499 1.447 12.6885 1.3376 12.5791C1.22821 12.4697 1.16675 12.3213 1.16675 12.1666V2.83325C1.16675 2.67854 1.22821 2.53017 1.3376 2.42077C1.447 2.31138 1.59537 2.24992 1.75008 2.24992H4.08342V1.08325H5.25008V2.24992H8.75008V1.08325H9.91675V2.24992ZM2.33341 5.74992V11.5833H11.6667V5.74992H2.33341ZM3.50008 6.91659H4.66675V8.08325H3.50008V6.91659ZM6.41675 6.91659H7.58342V8.08325H6.41675V6.91659ZM9.33342 6.91659H10.5001V8.08325H9.33342V6.91659Z"
        fill="#606060"
      />
    </g>
    <defs>
      <clipPath id="clip0_1691_7771">
        <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
</template>

<style scoped lang="scss"></style>
